import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/settings/job-positions/template/template-loading';

export const Route = createFileRoute('/_private/settings/job-positions/_template')({
  pendingComponent: TemplateLoading,
});
